<script setup lang="ts">
import { onMounted, useCssModule } from "vue";

import Modal from "@/components/modal/modal.vue";
import StepsButtons from "@/components/StepsButtons/StepsButtons.vue";
import WIDGET_ANALYTICS_EVENTS from "@/helpers/widgetAnalyticsEvents/widgetAnalyticsEvents";
import { useAnalytics } from "@/hooks/useAnalytics/useAnalytics";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useTIWStore } from "@/stores/tiw/tiw";

const classes = useCssModule();

onMounted(() => {
    useAnalytics(WIDGET_ANALYTICS_EVENTS.CREDIT_CARD_COMPLETE);
});

const TIWStore = useTIWStore();

function successAuthorization() {
    TIWStore.switchStep("thanksYou");
}
</script>

<template>
    <Modal class="tiw__step__creditCartPreAuthorization">
        <div class="tiw__step__creditCartPreAuthorization__body">
            <svg
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M47 6.01404C42.4417 3.37621 37.2666 1.99136 32 2.00004C15.431 2.00004 2 15.431 2 32C2 48.569 15.431 62 32 62C48.569 62 62 48.569 62 32C61.996 29.94 61.796 27.94 61.4 26"
                    stroke="#808D9A"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20 33.5C20 33.5 24.5 33.5 30.5 44C30.5 44 47.177 16.499 62 11"
                    stroke="#00C853"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            <div class="tiw__step__creditCartPreAuthorization__body__info">
                <p class="tiw__step__creditCartPreAuthorization__body__info__title">
                    {{
                        useTranslate(
                            "tiw__creditCardPreAuthorization__transactionComplete__success__title",
                        )
                    }}
                </p>
                <p class="tiw__step__creditCartPreAuthorization__body__info__text">
                    {{
                        useTranslate(
                            "tiw__creditCardPreAuthorization__transactionComplete__success__text",
                        )
                    }}
                </p>
            </div>

            <StepsButtons
                no-back-btn
                :click-to-next="successAuthorization"
                :class="classes.stepsButtonsContainer"
            />
        </div>
    </Modal>
</template>

<style lang="scss" src="./creditCartPreAuthorization.scss"></style>
<style module>
.stepsButtonsContainer {
    margin-top: 0; /* FIXME удали это, когда в компоненте StepsButtons будет удалён margin-top */
}
</style>
